import {NgModule} from "@angular/core";
import {CommonModule, DatePipe} from "@angular/common";
import {SharedLibraryModule} from "../shared-library/shared-library.module";
import {SavedSearchesComponent} from "./saved-searches.component";
import {SavedSearchesItemCardComponent} from "./components/saved-searches-item-card/saved-searches-item-card.component";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {A11yModule} from "@angular/cdk/a11y";
import {OverlayModule} from "@angular/cdk/overlay";
import {PortalModule} from "@angular/cdk/portal";
import {NoopAnimationsModule} from "@angular/platform-browser/animations";
import {NgxSliderModule} from "@m0t0r/ngx-slider";

@NgModule({
    imports: [
        CommonModule,
        SharedLibraryModule,
        FormsModule,
        ReactiveFormsModule,
        A11yModule,
        OverlayModule,
        PortalModule,
        NoopAnimationsModule,
        NgxSliderModule,
    ],
   declarations:[
       SavedSearchesComponent,
       SavedSearchesItemCardComponent
   ],
   providers:[
       DatePipe
   ]
})
export class SavedSearchesModule {
}
